export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11671.987e975e.jpg";